import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = [
    "form",
    "documentInput",
    "companyName",
    "streetInput",
    "numberInput",
    "complementInput",
    "nighborhoodInput",
    "cityInput",
    "stateInput",
    "loading",
  ];
  static values = { customerId: String };

  connect() {
    this.token = document.querySelector('meta[name="csrf-token"]')?.content;
  }

  fileUploaded(event) {
    const documentParmas = new URLSearchParams({
      document: event.detail.blob_signed_id,
      kind: event.detail.fileParams.kind,
    }).toString();
    const params = $(this.formTarget).serialize() + "&" + documentParmas;

    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden");
    }

    fetch("/customers/add_document", {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.token,
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Accept: "text/vnd.turbo-stream.html",
      },
      body: params,
    })
      .then((response) => response.ok && response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .finally(() => {
        if (this.hasLoadingTarget) {
          this.loadingTarget.classList.add("hidden");
        }
      });
  }

  removeDocument(event) {
    const $parent = $(event.target).closest(".customer-document-fields");
    $parent.find('[name*="_destroy"]').val("true");
    $parent.addClass("hidden");
  }

  // https://api-publica.speedio.com.br/buscarcnpj?cnpj=44056017000136

  cnpjChanged(event) {
    // Using setTimeout so we can get the masked value
    if (this.fetchingCompanyData) return;

    setTimeout(() => {
      const cnpj = event.target.value;
      if (cnpj.length != "18") {
        return;
      }

      this.fetchingCompanyData = true;

      fetch(`/customers/company_data?cnpj=${cnpj}`)
        .then((response) => {
          this.fetchingCompanyData = false;
          return response.json();
        })
        .then((data) => {
          this.populateData(data);
        })
        .catch(() => {
          this.fetchingCompanyData = false;
        });
    });
  }

  populateData(data) {
    $("#customer_company_name").val(data["RAZAO SOCIAL"]);
    if (data["CEP"] && data["CEP"].length) {
      $("#customer_company_address_attributes_postal_code").val(
        data["CEP"].slice(0, 5) + "-" + data["CEP"].slice(5)
      );
    }
    $("#customer_company_address_attributes_street").val(
      data["TIPO LOGRADOURO"] + " " + data["LOGRADOURO"]
    );
    $("#customer_company_address_attributes_number").val(data["NUMERO"]);
    $("#customer_company_address_attributes_complement").val(
      data["COMPLEMENTO"]
    );
    $("#customer_company_address_attributes_neighborhood").val(data["BAIRRO"]);
    $("#customer_company_address_attributes_city").val(data["MUNICIPIO"]);
    $("#customer_company_address_attributes_state").val(data["UF"]);
  }
}
